import { useEffect, useState } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Louisiana = () => {
  const [showAllCities, setShowAllCities] = useState(false);

  useEffect(() => {
    // Update page meta tags
    document.title = 'We Buy Valves Louisiana | Industrial Equipment Buyers Louisiana';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional valve buyers Louisiana - We buy surplus valves, Fisher control valves, instrumentation from Baton Rouge, Lake Charles refineries. Same-day response 214-854-5638.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'valve buyers louisiana, louisiana industrial equipment, surplus valves louisiana, fisher control valves louisiana, refinery equipment buyers');
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/louisiana');
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Louisiana Valve Buyers - Industrial Equipment Buyers | ValveSalesSupply');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Professional valve buyers Louisiana - We buy surplus valves, Fisher control valves, instrumentation from Baton Rouge, Lake Charles refineries. Same-day response 214-854-5638.');
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://valvesalessupply.com/louisiana');
    }

    // Add geo meta tags for Louisiana
    const geoRegion = document.createElement('meta');
    geoRegion.setAttribute('name', 'geo.region');
    geoRegion.setAttribute('content', 'US-LA');
    document.head.appendChild(geoRegion);

    const geoPlacename = document.createElement('meta');
    geoPlacename.setAttribute('name', 'geo.placename');
    geoPlacename.setAttribute('content', 'Louisiana');
    document.head.appendChild(geoPlacename);

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/louisiana/#webpage",
          "url": "https://valvesalessupply.com/louisiana",
          "name": "Louisiana Valve Buyers - Industrial Equipment Buyers | ValveSalesSupply",
          "description": "Professional valve buyers Louisiana - We buy surplus valves, Fisher control valves, instrumentation from Baton Rouge, Lake Charles refineries. Same-day response 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Louisiana",
                "item": "https://valvesalessupply.com/louisiana"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/louisiana/#place",
          "name": "Louisiana",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "LA",
            "addressCountry": "US"
          }
        },
        {
          "@type": "Service",
          "name": "Louisiana Industrial Equipment Purchasing",
          "provider": {
            "@type": "Organization",
            "name": "ValveSalesSupply",
            "telephone": "+1-214-854-5638",
            "email": "info@valvesalessupply.com"
          },
          "areaServed": {
            "@type": "State",
            "name": "Louisiana"
          },
          "description": "Professional valve and industrial equipment purchasing services throughout Louisiana including Baton Rouge, Lake Charles, and New Orleans areas."
        },
        {
          "@type": "ItemList",
          "name": "Louisiana Refining Centers",
          "numberOfItems": 5,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Baton Rouge Refining Complex",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Baton Rouge",
                  "@addressRegion": "LA"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Lake Charles Industrial Area",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Lake Charles",
                  "addressRegion": "LA"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Place",
                "name": "Belle Chasse Marine Terminal",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Belle Chasse",
                  "addressRegion": "LA"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Place",
                "name": "Norco Manufacturing Complex",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Norco",
                  "addressRegion": "LA"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Place",
                "name": "Geismar Chemical Complex",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Geismar",
                  "addressRegion": "LA"
                }
              }
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in Louisiana?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of industrial valves from Louisiana refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from ExxonMobil Baton Rouge, Phillips 66 Lake Charles, Shell Norco, and other Louisiana facilities."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond to Louisiana facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide same-day response to all Louisiana refineries and chemical plants. Our regional team can typically be on-site within 3-5 hours for equipment assessments throughout Louisiana, including Baton Rouge, Lake Charles, and New Orleans areas."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy petrochemical equipment from Louisiana plants?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We purchase petrochemical processing equipment, catalytic cracking units, distillation equipment, heat exchangers, and specialty chemical processing equipment from Louisiana's extensive petrochemical complex. We handle both refinery and chemical plant equipment."
              }
            },
            {
              "@type": "Question",
              "name": "What documentation is required for Louisiana facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide complete regulatory compliance documentation including proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with Louisiana DEQ and federal regulations."
              }
            },
            {
              "@type": "Question",
              "name": "Do you coordinate with hurricane season preparations?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We understand Gulf Coast weather patterns and can coordinate equipment removal during hurricane preparation periods or post-storm recovery operations. Our team is experienced with emergency equipment purchases during weather events throughout Louisiana."
              }
            },
            {
              "@type": "Question",
              "name": "How do you price equipment from Louisiana refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our pricing considers current market conditions, equipment condition, manufacturer specifications, and regional demand. We pay significantly above scrap prices for functional equipment and provide competitive pricing for all Louisiana facilities, from major refineries to smaller chemical plants."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup meta tags and schema
      document.head.removeChild(geoRegion);
      document.head.removeChild(geoPlacename);
      document.head.removeChild(script);
    };
  }, []);

  const louisianaFacilities = [
    { name: 'ExxonMobil Baton Rouge', location: 'Baton Rouge', capacity: '503,000 bpd' },
    { name: 'Phillips 66 Lake Charles', location: 'Lake Charles', capacity: '249,000 bpd' },
    { name: 'Shell Norco', location: 'Norco', capacity: '241,000 bpd' },
    { name: 'Valero Meraux', location: 'Meraux', capacity: '135,000 bpd' },
    { name: 'Citgo Lake Charles', location: 'Lake Charles', capacity: '427,000 bpd' }
  ];

  const louisianaCities = [
    'Abbeville', 'Alexandria', 'Baker', 'Bastrop', 'Baton Rouge', 'Bogalusa', 'Bossier City',
    'Breaux Bridge', 'Broussard', 'Carencro', 'Chalmette', 'Covington', 'Crowley', 'DeRidder',
    'Denham Springs', 'Donaldsonville', 'Eunice', 'Franklin', 'Gonzales', 'Gretna', 'Hammond',
    'Harahan', 'Harvey', 'Houma', 'Jennings', 'Kenner', 'Lafayette', 'Lake Charles', 'Leesville',
    'Mandeville', 'Marrero', 'Metairie', 'Minden', 'Monroe', 'Morgan City', 'Natchitoches',
    'New Iberia', 'New Orleans', 'Opelousas', 'Pineville', 'Plaquemine', 'Ponchatoula', 'Rayne',
    'Ruston', 'Shreveport', 'Slidell', 'Sulphur', 'Thibodaux', 'Ville Platte', 'West Monroe',
    'Westwego', 'Zachary'
  ];

  const faqData = [
    {
      question: "What types of valves do you buy in Louisiana?",
      answer: "We buy all types of industrial valves from Louisiana refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from ExxonMobil Baton Rouge, Phillips 66 Lake Charles, Shell Norco, and other Louisiana facilities."
    },
    {
      question: "How quickly can you respond to Louisiana facilities?",
      answer: "We provide same-day response to all Louisiana refineries and chemical plants. Our regional team can typically be on-site within 3-5 hours for equipment assessments throughout Louisiana, including Baton Rouge, Lake Charles, and New Orleans areas."
    },
    {
      question: "Do you buy petrochemical equipment from Louisiana plants?",
      answer: "Yes! We purchase petrochemical processing equipment, catalytic cracking units, distillation equipment, heat exchangers, and specialty chemical processing equipment from Louisiana's extensive petrochemical complex. We handle both refinery and chemical plant equipment."
    },
    {
      question: "What documentation is required for Louisiana facilities?",
      answer: "We provide complete regulatory compliance documentation including proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with Louisiana DEQ and federal regulations."
    },
    {
      question: "Do you coordinate with hurricane season preparations?",
      answer: "Absolutely! We understand Gulf Coast weather patterns and can coordinate equipment removal during hurricane preparation periods or post-storm recovery operations. Our team is experienced with emergency equipment purchases during weather events throughout Louisiana."
    },
    {
      question: "How do you price equipment from Louisiana refineries?",
      answer: "Our pricing considers current market conditions, equipment condition, manufacturer specifications, and regional demand. We pay significantly above scrap prices for functional equipment and provide competitive pricing for all Louisiana facilities, from major refineries to smaller chemical plants."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/37e25452ef7228a3964015a1bdfa9699.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              We Buy Valves Louisiana
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers Louisiana</strong> - We purchase surplus valves, control valves, 
              instrumentation, and refinery equipment from Baton Rouge, Lake Charles, and New Orleans area facilities. 
              Same-day response and competitive pricing for all Louisiana refineries and chemical plants.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET LOUISIANA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Louisiana Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">LOUISIANA VALVE BUYERS - GULF COAST EXPERTISE</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Louisiana is home to the largest refining capacity in the United States. As experienced 
                <strong className="text-[#1B3A5F]"> Louisiana valve buyers</strong> and 
                <strong className="text-[#1B3A5F]"> industrial equipment buyers</strong>, we understand 
                Louisiana's complex refining and petrochemical industry.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher control valves</strong>, 
                Rosemount instrumentation, gate valves, and complete control systems from 
                Baton Rouge, Lake Charles, and New Orleans area facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">18+</div>
                  <div className="text-gray-600">Louisiana Refineries</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">Same Day</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">25+ Years</div>
                  <div className="text-gray-600">Louisiana Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">MAJOR LOUISIANA FACILITIES</h3>
              <div className="space-y-4">
                {louisianaFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">{facility.capacity}</div>
                      <div className="text-gray-600 text-sm">Capacity</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Louisiana */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES LOUISIANA</h2>
            <p className="text-gray-600 text-xl">Louisiana's premier surplus valve buyers - serving America's refining capital</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Louisiana%20refinery%20surplus%20valves%20control%20valves%20gate%20valves%20ball%20valves%20Fisher%20Masoneilan%20Baton%20Rouge%20Lake%20Charles%20petrochemical%20plant%20equipment%20organized%20warehouse%20inventory%20professional%20industrial&width=600&height=400&seq=louisiana-surplus-valves-009&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Gulf Coast Refinery Grade Valves</h3>
                  <p>Premium surplus valves from America's largest refining complex</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">LOUISIANA SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are <strong className="text-[#1B3A5F]">Louisiana's premier surplus valve buyers</strong>, 
                serving the nation's largest refining complex along the Mississippi River. Our expertise in 
                Louisiana's refining and petrochemical operations ensures maximum value for your surplus 
                valve inventory from ExxonMobil, Shell, Phillips 66, and other major facilities.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Refinery Control Valves',
                    description: 'Fisher, Masoneilan from ExxonMobil Baton Rouge, Shell Norco facilities',
                    icon: 'ri-settings-4-line'
                  },
                  {
                    type: 'Petrochemical Valves',
                    description: 'Specialty valves from Lake Charles petrochemical complex',
                    icon: 'ri-flask-line'
                  },
                  {
                    type: 'Marine Terminal Valves',
                    description: 'Gate and ball valves from Mississippi River terminals',
                    icon: 'ri-ship-line'
                  },
                  {
                    type: 'Safety Systems',
                    description: 'Relief valves, safety valves from Louisiana chemical plants',
                    icon: 'ri-shield-check-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-600">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-white rounded-lg p-6 border border-gray-200">
                <h4 className="text-[#1B3A5F] font-bold mb-3">Louisiana Hurricane Preparedness:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-cloudy-2-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Storm preparation removal</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Same-day response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Emergency logistics</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-shield-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Weather-ready operations</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Louisiana Cities Dropdown Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES IN ALL LOUISIANA CITIES</h2>
            <p className="text-gray-600 text-xl mb-8">Serving refineries and industrial facilities across Louisiana</p>
            
            <button
              onClick={() => setShowAllCities(!showAllCities)}
              className="bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2B4A6F] transition-all duration-300 inline-flex items-center whitespace-nowrap"
            >
              {showAllCities ? 'Hide Cities' : 'View All Louisiana Cities'}
              <i className={`ml-2 ${showAllCities ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
            </button>
          </div>

          {showAllCities && (
            <div className="mt-12">
              <div className="bg-[#F5F7FA] rounded-2xl p-8 mb-8">
                <div className="grid md:grid-cols-3 gap-6 text-center">
                  <div>
                    <div className="text-[#1B3A5F] text-3xl font-bold mb-2">50+</div>
                    <div className="text-gray-600">Louisiana Cities Served</div>
                  </div>
                  <div>
                    <div className="text-[#1B3A5F] text-3xl font-bold mb-2">3-5 Hours</div>
                    <div className="text-gray-600">Average Response Time</div>
                  </div>
                  <div>
                    <div className="text-[#1B3A5F] text-3xl font-bold mb-2">Same Day</div>
                    <div className="text-gray-600">Equipment Removal Available</div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {louisianaCities.map((city, index) => (
                  <div
                    key={index}
                    className="bg-white border-2 border-gray-200 rounded-lg p-4 hover:border-[#1B3A5F] transition-all duration-300 cursor-pointer"
                  >
                    <div className="flex items-center">
                      <i className="ri-map-pin-line text-[#1B3A5F] mr-3 text-xl"></i>
                      <div>
                        <div className="font-bold text-[#1B3A5F]">We Buy Valves {city} LA</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">LOUISIANA VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment to Louisiana buyers</p>
          </div>
          
          <div className="space-y-8">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Louisiana;
